import React, { FC, useMemo } from "react";
import { observer } from "mobx-react-lite";
import styles from "./index.module.scss";
import { galleryLangRecords } from "@/pages/Gallery/lang";
import { langStore } from "@noli/business";

interface SelectProps {
  inHeader?: boolean;
  current: string;
  onSelect: (current: string) => void;
  data: { code: string; text: string }[];
}

const Select: FC<SelectProps> = (props) => {
  const lang = langStore.tgt;

  const { current, onSelect, data, inHeader } = props;
  const codelistItemNode = useMemo(() => {
    return data.map((prod) => {
      return (
        <li
          key={prod.code}
          className={current === prod.code ? styles.active : ""}
          onClick={() => {
            current !== prod.code && onSelect(prod.code);
          }}
        >
          {prod.text}
        </li>
      );
    });
  }, [data, current]);
  return (
    <div className={inHeader ? styles.inHeaderSelectWrapper : styles.selectWrapper}>
      <div className={styles.exhibitionWrapper}>
        {data.find((prod) => prod.code === current)?.text}
      </div>
      <ul className={styles.optionWrapper}>{codelistItemNode}</ul>
    </div>
  );
};
export default observer(Select);
